<template>  
  <div class="container">
        <div class="row">
    <!-- Loading state with skeleton loader -->
    <div v-if="authorStore.loading" class="row g-4">
      <div v-for="n in 3" :key="n" class="col-12 col-md-6 col-lg-4">
        <div class="skeleton-card"></div>
      </div>
    </div>

    <!-- Error state -->
    <div v-else-if="authorStore.error" class="alert alert-danger text-center">
      {{ authorStore.error }}
    </div>

    <!-- Main content with profile cards -->
    <div v-else-if="authorStore.administrataEProkurorise.length > 0" class="row g-4 mt-4">
      <div
        v-for="autor in authorStore.administrataEProkurorise"
        :key="autor.id"
        class="col"
      >
        <div class="profile-card-wrapper d-flex">
          <ProfileCard
            :title="autor.postionName"
            :avatar="autor.imageUrl"
            :fullname="autor.firstName + ' ' + autor.lastName"
            :position="autor.postionName"
            :birthday="autor.birthdate"
            :address="autor.address"
         
            :cv_url="autor.cvUrl"
            facebook="#"
            @primary="pranoFunksioni"
            @secondary="anuloFunksioni"
            class="shadow-sm"
          />
          <p class="description-text text-muted" v-html="autor.description"></p>
        </div>
      </div>
    </div>

    <!-- Empty state -->
    <div v-else class="text-center py-5">
      <p class="text-muted">No data available.</p>
    </div>

  </div>
  </div>
</template>

<script>

import { useAutorStore } from '@/store/AuthorStore/authorStore';
import ProfileCard from './PresecutorChiefTemplate.vue';
//import Persecutor from '../share/PersecutorTemplate.vue';

export default {
  name: 'OfficialProfile',
  components: { ProfileCard },
  props: {
    prokuroriaId: {
      type: Number,
      default: 6,
    },
    categoryId: {
      type: Number,
      default: 2210,
    },
    language: {
      type: String,
      default: 'AL',
    },
  },
  data() {
    return {
      authorStore: useAutorStore(),
    };
  },
  methods: {
    resetStoreState() {
      this.authorStore.administrataEProkurorise = [];
      this.authorStore.loading = false;
      this.authorStore.error = null;
    },
    pranoFunksioni() {
      // Handle primary action (e.g., accept)
    },
    anuloFunksioni() {
      // Handle secondary action (e.g., cancel)
    },
  },
  mounted() {
    this.resetStoreState();
    this.authorStore.loading = true;
    this.authorStore.getAdministratoreteProkurorive({
      prokuroriaId: this.prokuroriaId,
      categoryId: this.categoryId,
      positionId: 0,
      language: this.language,
    });
  },
};
</script>

<style scoped>
/* Define custom properties for consistent theming */
:root {
  --primary: #007bff;
  --secondary: #6c757d;
  --background-light: #f8f9fa;
  --background-gradient: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  --text-dark: #2c3e50;
  --text-muted: #6c757d;
  --shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Base container styling */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

/* Skeleton loader for loading state */

@keyframes skeleton-loading {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* Profile card wrapper */
.profile-card-wrapper {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  padding: 1rem;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  animation: fadeIn 0.5s ease-out forwards;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.profile-card-wrapper:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

/* Fade-in animation for cards */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Profile card styling */
:deep(.profile-card) {
  border: none;
  border-radius: 12px;
  background: #fff;
  padding: 1.5rem;
  text-align: left;
  flex: 1;
  min-width: 0;
}

/* Description text */
.description-text {
  font-size: 0.9rem;
  line-height: 1.6;
  color: var(--text-muted);
  flex: 1;
  margin: 0;
  padding: 1rem;
  overflow-wrap: break-word;
}

/* Profile card image */
:deep(.profile-card img) {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 50%;
  margin-bottom: 1rem;
  border: 3px solid #e9ecef;
}

/* Profile card title */
:deep(.profile-card h3) {
  font-size: 1.5rem;
  color: var(--text-dark);
  margin-bottom: 0.5rem;
}

/* Profile card paragraph */
:deep(.profile-card p) {
  font-size: 1rem;
  color: var(--text-muted);
  margin-bottom: 0.75rem;
}

/* Buttons */
:deep(.profile-card button) {
  transition: background-color 0.3s ease, transform 0.2s ease;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  background-color: var(--primary);
  border: none;
  color: #fff;
}

:deep(.profile-card button:hover) {
  transform: scale(1.05);
  background-color: darken(var(--primary), 10%);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .profile-card-wrapper {
    flex-direction: column;
    padding: 0.75rem;
  }

  :deep(.profile-card img) {
    width: 80px;
    height: 80px;
  }

  .description-text {
    padding: 0.5rem 0;
  }
}
</style>